module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/google_play.60d26496.svg";